// All site content - easy for father/client to edit
export const SITE = {
  brand: "Silent Wald",
  tagline: "A Forest Sanctuary",
  phone: " +919912917007", // Replace with real number
  whatsapp: " +919912917007",
  email: "stay@silentwald.com",
  address: "Silent Wald Resort, Shamirpet, Secunderabad, Telangana 500078, India",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.823!2d78.6109622!3d17.534766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb8329f8e4f1c3%3A0x379b59646bc4198d!2sSile[...]",
  instagram: "https://www.instagram.com/silentwald_resorts/",
  established: 2000,
  acres: 250,
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Stay", href: "#stay" },
  { label: "Amenities", href: "#amenities" },
  { label: "Experiences", href: "#experiences" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const HERO_IMAGE = "/images/silentwald/MAIN image for hompage hero image.jpeg";

export const ABOUT_IMAGES = [
  "/images/silentwald/exterior 1.jpeg",
  "/images/silentwald/exterior 2.jpeg",
];

export const COTTAGES = [
  {
    name: "The Forest Suite",
    desc: "Air-conditioned premium cottage with kitchenette, perfect for couples and small families seeking quiet immersion.",
    feat: ["AC + Heater", "Private Veranda", "Kitchenette", "Premium Linen"],
    img: "/images/silentwald/interior 1.jpeg",
  },
  {
    name: "Lawn-View Cottage",
    desc: "Walk straight onto the lawn. Designed for guests of weddings & gatherings staying on-property.",
    feat: ["AC", "Twin / Queen", "Garden Access", "Refrigerator"],
    img: "/images/silentwald/interior 2.jpeg",
  },
  {
    name: "Family Farmhouse",
    desc: "Spacious shared farmhouse — multi-room, perfect for groups, retreats, and joint family stays.",
    feat: ["Multi-Bedroom", "Living Lounge", "Kitchen", "Power Backup"],
    img: "/images/silentwald/interior 3.jpeg",
  },
];

export const AMENITIES = [
  { title: "In-house Catering", desc: "Veg & non-veg, multi-cuisine.", icon: "UtensilsCrossed" },
  { title: "Caretaker On-Call", desc: "24×7 guest support.", icon: "BellRing" },
];

export const EXPERIENCES = [
  {
    title: "Forest Weddings",
    blurb: "Exchange vows under a canopy of ancient trees. Lawns for 700, halls for 500, and a backdrop nature itself designed.",
    img: "/images/silentwald/exterior 3.jpeg",
  },
  {
    title: "Corporate Retreats",
    blurb: "Strategy off-sites, team building, leadership offsites — all in 250 acres of distraction-free quiet.",
    img: "/images/silentwald/exterior 4.jpeg",
  },
  {
    title: "Family Getaways",
    blurb: "Weekend escapes, birthdays, anniversaries, and reunions. Pool, bonfire, BBQ, and stories under stars.",
    img: "/images/silentwald/night 1.jpeg",
  },
  {
    title: "Film & Photo Shoots",
    blurb: "A favourite location for production crews. Multiple landscapes, controlled access, and on-site logistics.",
    img: "/images/silentwald/night 2.jpeg",
  },
];

export const GALLERY = [
  "/images/silentwald/MAIN image for hompage hero image.jpeg",
  "/images/silentwald/exterior 1.jpeg",
  "/images/silentwald/exterior 2.jpeg",
  "/images/silentwald/exterior 3.jpeg",
  "/images/silentwald/exterior 4.jpeg",
  "/images/silentwald/interior 1.jpeg",
  "/images/silentwald/interior 2.jpeg",
  "/images/silentwald/interior 3.jpeg",
  "/images/silentwald/night 1.jpeg",
  "/images/silentwald/night 2.jpeg",
];

export const TESTIMONIALS = [
  {
    quote: "Hosted my daughter's wedding here. The lawns are simply stunning — guests still talk about that night.",
    name: "Rajesh K.",
    role: "Wedding Host",
    rating: 5,
  },
  {
    quote: "Our annual corporate offsite. 60 leaders, three days of strategy, no city noise. Perfect.",
    name: "Priya M.",
    role: "HR Director, Hyderabad",
    rating: 5,
  },
  {
    quote: "We come here for every birthday. The kids love the pool, we love the silence.",
    name: "Anand & Family",
    role: "Repeat Guest",
    rating: 5,
  },
  {
    quote: "Filmed two ad campaigns at Silent Wald. Hospitality is rare for a property of this scale.",
    name: "Krithika S.",
    role: "Producer, Annapurna Films",
    rating: 4.8,
  },
];

export const FAQS = [
  { q: "Where exactly is Silent Wald located?", a: "We are situated in Shamirpet/Keesara, on the outskirts of Secunderabad — about 45 minutes from Hyderabad airport and 30 minutes from Secunder[...]" },
  { q: "How many guests can the lawns host?", a: "Our main lawn comfortably hosts 700 floating guests; the indoor hall seats up to 300 and floats 500. Smaller poolside gatherings of 20–50 are a[...]" },
  { q: "What is the typical cost?", a: "Day rentals begin around ₹50,000 with catering plates from ₹500–₹1,000 depending on cuisine. Wedding & multi-day packages are custom-quoted — ple[...]" },
  { q: "Can we bring our own caterer / DJ / decorator?", a: "Yes. Outside catering, decor, and DJs are permitted. We also have trusted in-house partners if you prefer a hands-off experience." },
  { q: "Is alcohol permitted?", a: "Yes, alcohol is permitted on-property. Smoking is allowed in designated outdoor zones." },
  { q: "What's the check-in / check-out time?", a: "Check-in from 12:00 PM, check-out by 11:00 AM. Late check-out subject to availability." },
];
